'use strict';

var dialog = require('./dialog'),
	product = require('./pages/product'),
	util = require('./util'),
	linchpin = require('int_googletagmanager/linchpin/product'),
	_ = require('lodash');


var makeUrl = function (url, source, productListID) {
	if (source) {
		url = util.appendParamToURL(url, 'source', source);
	}
	if (productListID) {
		url = util.appendParamToURL(url, 'productlistid', productListID);
	}
	return url;
};

var removeParam = function (url) {
	if (url.indexOf('?') !== -1) {
		return url.substring(0, url.indexOf('?'));
	} else {
		return url;
	}
};

/**
 * @private
 * @function redirects to PDP with #qv-review hash added
 */
var writeReviewPDPRedirect = function () {
	var qvInlineRatings = document.getElementById('qvInlineRatings');
	if (qvInlineRatings) {
		qvInlineRatings.addEventListener('click', function (e) {
			e.stopPropagation();
			window.location.href = $(this).data('url') + '#qv-review';
		}, true);
	}
};

var quickview = {
	init: function () {
		if (!this.exists()) {
			this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
		}
		this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
			return $(thumbLink).attr('href');
		});
	},

	setup: function (qvUrl) {
		var $btnNext = $('.quickview-next'),
			$btnPrev = $('.quickview-prev');

		product.init();
		writeReviewPDPRedirect();

		this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
			return removeParam(url) === removeParam(qvUrl);
		});

		// hide the buttons on the compare page or when there are no other products
		if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
			$btnNext.hide();
			$btnPrev.hide();
			return;
		}

		if (this.productLinkIndex === this.productLinks.length - 1) {
			$btnNext.prop('disabled', true);
		}
		if (this.productLinkIndex === 0) {
			$btnPrev.prop('disabled', true);
		}

		$btnNext.on('click', function (e) {
			e.preventDefault();
			this.navigateQuickview(1);
		}.bind(this));
		$btnPrev.on('click', function (e) {
			e.preventDefault();
			this.navigateQuickview(-1);
		}.bind(this));
	},

	/**
	 * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
	 */
	navigateQuickview: function (step) {
		// default step to 0
		this.productLinkIndex += (step ? step : 0);
		var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
		dialog.replace({
			url: url,
			callback: this.setup.bind(this, url)
		});
	},

	/**
	 * @description show quick view dialog
	 * @param {Object} options
	 * @param {String} options.url - url of the product details
	 * @param {String} options.source - source of the dialog to be appended to URL
	 * @param {String} options.productlistid - to be appended to URL
	 * @param {Function} options.callback - callback once the dialog is opened
	 */
	show: function (options) {
		var url;
		if (!this.exists()) {
			this.init();
		}
		url = makeUrl(options.url, options.source, options.productlistid);

		dialog.open({
			target: this.$container,
			url: url,
			options: {
				width: 600,
				title: 'Product Quickview',
				dialogClass: options.dialogClass || 'quickview-dialog',
				open: function () {
					this.setup(url);
					$('.quickview-dialog').addClass('height-auto');
					if (typeof options.callback === 'function') { options.callback(); }
					$('.pdp-main .product-tabs').tabs ({
						collapsible: true,
						active: false
					});
					// GTM Linchpin analytics
					if (SitePreferences.GTM_ENABLED) {
						linchpin.triggerQuickViewEvent();
					}
				}.bind(this),
				close: function () {
					$('.quickview-dialog').removeClass('height-auto');
					linchpin.trackPageView();
				}
			}
		});
	},
	exists: function () {
		return this.$container && (this.$container.length > 0);
	}
};

module.exports = quickview;
